import { hasAnyPermission } from "@/lib/module-access";

/** Permissions that open an Ops page; the API checks the same ones. */
export function opsPathPermissions(pathname: string): string[] {
  if (pathname === "/ops" || pathname === "/ops/") return ["ops.dashboard.view"];
  if (pathname.startsWith("/ops/projects")) return ["ops.projects.view"];
  if (pathname.startsWith("/ops/audit-logs")) return ["ops.audit.view"];
  return ["ops.view"];
}

export function canAccessOpsPath(pathname: string, permissions: string[]): boolean {
  // The dashboard page itself redirects project-only users to /ops/projects.
  if (pathname === "/ops" || pathname === "/ops/") {
    return hasAnyPermission(permissions, ["ops.dashboard.view", "ops.projects.view"]);
  }
  return hasAnyPermission(permissions, opsPathPermissions(pathname));
}
